<template>
    <section class="sc-dashboard">
        <div class="container flex-wrapper">
            <main class="main-content layout-calc">
                <h2 class="tariff-title">{{ tariff.name }}</h2>
                <div class="package-item max-width-500" v-if="Object.keys(tariff).length">
                    <ul>
                        <li class="package-info"><p><span class="color-red">{{ tariff.speed }}</span> {{ $t('pages.internet.speed') }}</p></li>
                    </ul>
                </div>
            </main>
        </div>
    </section>
</template>

<script>
import Internet from './Internet';
export default Internet;
</script>
